<template>
  <div
    class="DesktopMenuContent bg-lightest border-r border-light type-sm relative select-none"
    :class="{
      animateIn: depth > 0
    }"
  >
    <!-- * * * * * * head -->
    <div v-if="depth > 0" class="type-headline-lg pl-20 pt-20">
      {{ menuName }}
    </div>

    <div
      class="py-8 pr-8"
      :class="{
        'pl-8': depth > 0
      }"
    >
      <!-- * * * * * * primary menu -->
      <div
        v-if="parentMenu?.mobileButton && parentMenu?.link && parentMenu.mobileButton !== ''"
        class="w-[calc(100% - 24px)] -ml-12"
      >
        <nuxt-link
          :to="$sbLinkFix(parentMenu?.link)"
          :target="$sbLinkTarget(parentMenu?.link)"
          class="DeskNav"
        >
          {{ parentMenu?.mobileButton }}
        </nuxt-link>
      </div>
      <div class="first:-ml-0 even:-ml-12">
        <template
          v-for="link in content"
          :key="link._uid"
        >
          <div
            v-if="link.children.length > 0"
            class="DeskNav"
            :class="{
              'text-text-errorStrong': checkDesign(link.design, 'sale'),
              'selected': uiStore.isParentOfOpenMenu(link._uid),
            }"
          >
            <button
              class="flex flex-1 items-center text-left h-full"
              type="button"
              aria-haspopup="true"
              :aria-expanded="uiStore.isParentOfOpenMenu(link._uid)"
              @click="clickMenu($sbLinkFix(link.link), true, link._uid)"
            >
              <div v-if="link.icon && link.icon.filename" class="basis-24 shrink-0">
                <img
                  :src="link.icon.filename"
                  class="w-24 h-24"
                  :alt="link.title"
                >
              </div>
              <div
                class="basis-full"
                :class="{
                  'pl-12': link.icon?.filename
                }"
              >
                {{ link.title }}
              </div>
            </button>
            <MenuItemFavorite
              v-if="!userStore.isCustomerSuccessUser"
              :item="link"
              :hide-title="true"
            />
            <div class="basis-24 shrink-0">
              <img
                src="/icons/angle-right.svg"
                class="h-20 w-20"
                alt=""
              >
            </div>
          </div>
          <nuxt-link
            v-else
            class="DeskNav"
            :class="{
              'text-text-errorStrong': checkDesign(link.design, 'sale'),
            }"
            :to="$sbLinkFix(link.link)"
            :target="$sbLinkTarget(link.link)"
          >
            <div v-if="link.icon && link.icon.filename" class="basis-24">
              <img
                :src="link.icon.filename"
                class="w-24 h-24"
                :alt="link.title"
              >
            </div>
            <div
              class="basis-full"
              :class="{
                'pl-12': link.icon?.filename
              }"
            >
              {{ link.title }}
            </div>
            <MenuItemFavorite
              v-if="!userStore.isCustomerSuccessUser"
              :item="link"
              :hide-title="true"
            />
          </nuxt-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalContentStore } from '~/store/globalContent';
import type { StoryBlokNestableNav } from '#constants/types/storyblok';
import { useUiStore } from '~/store/ui';
import { useUserStore } from '~/store/user';
import useMenuHelper from '~/composables/useMenuHelper';
import MenuItemFavorite from '~/components/menu/MenuItemFavorite.vue';
const uiStore = useUiStore();
const userStore = useUserStore();
const globalContent = useGlobalContentStore();

const props = defineProps<{
  parent: string,
  depth: number,
}>();

let content = [] as StoryBlokNestableNav[];
let menuName = 'Menu';

let parentMenu = null as StoryBlokNestableNav | null;

const submenu = globalContent.getNavByUid(props.parent);
if (submenu) {
  parentMenu = submenu;
  content = submenu.children;
  menuName = submenu.title;
}

const router = useRouter();
const clickMenu = (url: string | null, children: boolean | null, _uid: string) => {
  if (children || _uid === 'selectCountry') {
    uiStore.addSideMenuParent(_uid, props.parent);
  } else if (url) {
    const isExternal = (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//'));
    if (isExternal) {
      window.location.href = url;
    } else {
      router.push({ path: url });
    }
    uiStore.closeDesktopMenu();
  }
};

const { checkDesign } = useMenuHelper();

</script>

<style scoped lang="postcss">
.DeskNav {
  @apply w-full h-48 pl-12 pr-8 flex items-center justify-between text-text-subtle leading-single transition-all cursor-pointer;

  &.selected {
    @apply bg-bg-secondary text-text-base cursor-default font-semibold;
  }

  &:hover:not(.selected) {
    @apply bg-bg-subtle  text-text-base;
  }
}
.animateIn {
  animation: .0s ease-out 0s 1 SlideIn;
}
@keyframes SlideIn {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(-0%);
  }
}
</style>
